<template>
  <div class="document-dialog" v-if="showLoginDialogs">
    <el-dialog
      :visible.sync="showLoginDialogs"
      top="30vh"
      :center="false"
      width="380px"
      style="border-radius:15px;"
      :close-on-click-modal="false"
      :before-close="close"
      :show-close="false"
      @keyup.enter.native="login"
    >
      <div
        slot="title"
        class="dialog-title setborder ml5 left"
        v-if="isPassLogin && !isRegister && !forgetPass"
      >
        <span class="title_name">用户登录</span
        ><span class="explain">(老用户支持用户名登录)</span>
      </div>
      <div
        slot="title"
        class="check-login"
        v-if="isPassLogin && !isRegister && !forgetPass"
      >
        <div class="anquan-tips">
          <i class="icons tips-info"></i>
          扫码登录在这里
        </div>
        <span
          @click="weiXinLogin"
          class="toweixin"
          title="切换其他登录方式"
        ></span>
      </div>
      <!--      用户注册标题-->
      <div
        slot="title"
        class="dialog-title setborder ml5 left"
        v-if="isPassLogin && isRegister"
      >
        <span class="title_name">用户注册</span>
      </div>
      <div
        slot="title"
        class="check-register"
        @click="backLogin"
        v-if="isPassLogin && isRegister"
      >
        <span>返回登录</span>
      </div>

      <!-- 找回密码-->
      <div
        slot="title"
        class="dialog-title setborder ml5 left"
        v-if="isPassLogin && forgetPass"
      >
        <span class="title_name">找回密码</span>
      </div>
      <div
        slot="title"
        class="check-register"
        @click="backLogin"
        v-if="isPassLogin && forgetPass"
      >
        <span>返回登录/注册</span>
      </div>
      <div
        slot="title"
        class="dialog-title setborder ml5 left"
        v-if="!isPassLogin"
      >
        <span class="title_name">微信登录或注册</span>
      </div>
      <div slot="title" class="check-login" v-if="!isPassLogin">
        <div class="anquan-tips">
          <i class="icons tips-info"></i>
          密码登录在这里
        </div>
        <span @click="passLogin" class="topass" title="切换其他登录方式"></span>
      </div>
      <!--      <div slot="title" class="dialog-title mr10 left fr" @click="jumpLogin">-->
      <!--        5118账号登录-->
      <!--        <i class="icon-account-new"></i>-->
      <!--      </div>-->
      <div slot="title" class="dialog-title fr">
        <span class="close" @click="close">
          <i class="el-icon-error"></i>
        </span>
      </div>
      <div class="login-tip">
        <div v-if="!isPassLogin">
          <div class="app-account-qrcode">
            <div class="qrcode" id="wx_login" style="position: relative;">
              <div class="qrcode-box">
                <div class="qrcode-div">
                  <img :src="url" alt="" width="148" height="148" />
                </div>
                <div
                  class="getPublicQrCode"
                  v-if="isOverdue"
                  @click="getPublicQrCode"
                >
                  <div>
                    二维码失效
                    <br />
                    请点击刷新
                  </div>
                </div>
                <div class="tips-div">
                  <img
                    src="../../assets/image/prompt/scan_sample.png"
                    alt=""
                    width="148"
                    height="148"
                  />
                </div>
              </div>
            </div>
            <div class="qrcode-tips">
              <i></i>
              <div class="scantext">
                <div>扫码<span class="scana">关注公众号</span></div>
                <div>立即登录</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else style="height: 255px">
          <div v-if="isPassLogin && isRegister">
            <div class="app-account-login">
              <div class="error" v-cloak>
                {{ regErrorTip }}
              </div>
              <div class="zhanghao">
                <input
                  type="text"
                  class="text"
                  style="height: 37px;"
                  name="account"
                  v-model.trim="regForm.uname"
                  v-focus
                  placeholder="请输入手机号码"
                  autocomplete="off"
                  @input="regErrorTip = ''"
                />
              </div>
              <div class="zhanghao">
                <input
                  type="password"
                  class="text"
                  style="height: 37px;"
                  name="password"
                  v-model.trim="regForm.pwd"
                  placeholder="请设置密码，不少于6-30个字符"
                  autocomplete="off"
                  @input="regErrorTip = ''"
                />
              </div>
              <div class="zhanghao" style="width: 50%;display: inline-block;">
                <input
                  type="text"
                  class="text"
                  style="height: 37px;"
                  name="securityCode"
                  v-model.trim="regForm.mobileCode"
                  placeholder="短信验证码"
                  autocomplete="off"
                  @input="regErrorTip = ''"
                />
              </div>
              <button
                @click="goRegisterCodeClick"
                :class="[
                  phoneNumberAll
                    ? timeOut > 0
                      ? 'noPhoneCode'
                      : 'getPhoneCode'
                    : 'noPhoneCode'
                ]"
              >
                {{
                  timeOut > 0
                    ? "重新发送" + "(" + timeOut + "S)"
                    : "点击获取验证码"
                }}
              </button>
              <div class="agree">
                <el-checkbox v-model="checked"></el-checkbox>
                我已阅读、了解并同意
                <a
                  href="https://account.5118.com/signin/protocol"
                  target="_blank"
                  >《5118用户协议》</a
                >的内容及条款
              </div>
              <div>
                <button
                  :class="[checked ? 'button' : 'gbutton']"
                  style="margin-top:20px;"
                  @click="register"
                  @keyup="register"
                >
                  注册
                </button>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-if="isPassLogin && forgetPass">
              <div class="app-account-login">
                <div class="zhanghao">
                  <input
                    type="text"
                    class="text"
                    style="height: 37px;"
                    name="account"
                    v-model.trim="forgetForm.mobile"
                    v-focus
                    placeholder="请输入手机号或邮箱"
                    autocomplete="off"
                    @input="regErrorTip = ''"
                  />
                </div>
                <div class="zhanghao">
                  <input
                    type="password"
                    class="text"
                    style="height: 37px;"
                    name="password"
                    v-model.trim="forgetForm.password"
                    placeholder="请输入密码"
                    autocomplete="off"
                    @input="regErrorTip = ''"
                  />
                </div>
                <div class="zhanghao">
                  <input
                    type="password"
                    class="text"
                    style="height: 37px;"
                    name="password"
                    v-model.trim="forgetForm.password2"
                    placeholder="请输入确认密码"
                    autocomplete="off"
                    @input="regErrorTip = ''"
                  />
                </div>
                <div class="zhanghao" style="width: 50%;display: inline-block;">
                  <input
                    type="text"
                    class="text"
                    style="height: 37px;"
                    name="securityCode"
                    v-model.trim="forgetForm.code"
                    placeholder="请输入验证码"
                    autocomplete="off"
                    @input="regErrorTip = ''"
                  />
                </div>
                <button
                  @click="goForGetCodeClick"
                  :class="[
                    forgetForm.mobile
                      ? timeOut > 0
                        ? 'noPhoneCode'
                        : 'getPhoneCode'
                      : 'noPhoneCode'
                  ]"
                >
                  {{
                    timeOut > 0
                      ? "重新发送" + "(" + timeOut + "S)"
                      : "点击获取验证码"
                  }}
                </button>
                <div class="error" v-cloak>
                  {{ forgetErrorTip }}
                </div>
                <div>
                  <button
                    class="button"
                    style="margin-top:20px;"
                    @click="forget"
                    @keyup="forget"
                  >
                    确认修改
                  </button>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="app-account-login">
                <div class="error" v-cloak>
                  {{ errorTip }}
                </div>
                <div class="resetMsg" v-if="isReset">
                  因内容神器用户体系调整，您的账号需要重置密码
                  <span @click="toforget">去重置</span>
                </div>
                <div class="zhanghao">
                  <input
                    type="text"
                    class="text"
                    style="height: 37px;"
                    name="account"
                    v-model.trim="form.account"
                    v-focus
                    placeholder="请输入用户名、手机号或邮箱"
                    autocomplete="off"
                    @input="clearReset"
                  />
                </div>
                <div class="zhanghao">
                  <input
                    type="password"
                    class="text"
                    style="height: 37px;"
                    name="password"
                    v-model.trim="form.password"
                    placeholder="请输入密码"
                    autocomplete="off"
                    @input="clearReset"
                  />
                </div>
                <label class="checkbox"
                  ><input
                    type="checkbox"
                    v-model="saveUser"
                    style="margin-top: -2px"
                  /><span style="margin-left: 3px">永不过期</span></label
                >
                <a href="javascript:;" class="forget-btn" @click="toforget"
                  >密码忘记？</a
                >
                <button
                  class="button"
                  :class="{ disable: isLoading }"
                  style="margin-top:20px;"
                  @click="login"
                  @keyup="login"
                >
                  登 录
                </button>
                <div v-if="isPassLogin" class="footer">
                  <a href="javascript:;" @click="toRegister">免费注册</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer ml5 center"></div>
    </el-dialog>
    <vcodedialog
      :successcallback="vcode_successcallback"
      v-if="vcode_isShow"
      @isShowHandle="isShowHandle"
    ></vcodedialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import config from "../../assets/script/config/index.js";
import Cookies from "js-cookie";
// import Course from "@/components/share/Course";
import vcodedialog from "@/components/dialogs/vcode_dialog";
export default {
  name: "userLogin",
  components: {
    vcodedialog
  },
  props: {
    showLoginDialogs: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isPassLogin: false,
      isRegister: false,
      url: "",
      stateInterval: null,
      returnurl: window.location.href || "",
      isOverdue: false,
      form: {
        account: "",
        password: ""
      },
      regForm: {
        uname: "",
        pwd: "",
        mobileCode: ""
      },
      forgetForm: {
        mobile: "",
        password: "",
        password2: "",
        code: "",
        uid: ""
      },
      errorTip: "",
      regErrorTip: "",
      forgetErrorTip: "",
      isLoading: false,
      saveUser: false,
      checked: true,
      phoneNumberAll: false,
      forgetPass: false,
      isReset: false,
      timeOut: 0,
      getUid: "",
      vcode_successcallback: null,
      vcode_isShow: false
    };
  },
  mounted() {
    this.getPublicQrCode();
    // this.getCookie();
  },
  beforeDestroy() {
    this.isSetSaveState(true);
  },
  watch: {
    regForm: {
      async handler(val) {
        if (!this.phoneNumberAll) {
          if (val.uname.length > 11) {
            this.regErrorTip = "手机格式不正确";
          }
          if (val.uname.length === 11) {
            let reg = /^[0-9]{11}$/g;
            if (!reg.test(val.uname)) {
              this.phoneNumberAll = false;
              this.regErrorTip = "手机格式不正确";
            } else {
              let checkData = { mobile: this.regForm.uname, type: "mobile" };
              let checkMsg = await this.getMobileCheck(checkData);
              if (checkMsg.status === 2) {
                this.regErrorTip = "手机号已注册";
                this.phoneNumberAll = false;
              } else {
                this.phoneNumberAll = true;
              }
            }
          } else {
            this.phoneNumberAll = false;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("user", [
      "publicQrCode",
      "publicQrCodeState",
      "publicLogin",
      "userLogin",
      "getForGetCode",
      "getUserReset",
      "getUserRegister",
      "getMobileVerifyCode",
      "getMobileCheck"
    ]),
    ...mapMutations("editorControl", ["setisSaveState"]),
    isSetSaveState(type) {
      this.setisSaveState(type);
    },
    weiXinLogin() {
      this.isPassLogin = false;
      this.getPublicQrCode();
    },
    clearReset() {
      this.errorTip = "";
      this.isReset = false;
    },
    backLogin() {
      this.forgetPass = false;
      this.isRegister = false;
      this.errorTip = "";
      this.isReset = false;
    },
    setTimeOut(time) {
      this.timeOut = time;
      this.result = false;
      let timeout = setInterval(() => {
        if (this.timeOut <= 0) {
          this.percentage = 0;
          clearInterval(timeout);
        } else {
          this.timeOut = this.timeOut - 1;
        }
      }, 1000);
    },
    async goRegisterCodeClick() {
      if (this.phoneNumberAll && this.timeOut <= 0) {
        this.vcode_successcallback = this.goRegisterCode;
        this.vcode_isShow = true;
      }
    },
    async goRegisterCode(codeText, guidText) {
      if (this.phoneNumberAll && this.timeOut <= 0) {
        let data = {
          mobile: this.regForm.uname,
          guid: guidText,
          Vcode: codeText
        };
        let result = await this.getMobileVerifyCode(data);
        if (result.status === 1) {
          this.setTimeOut(60);
        }
        // console.log(result);
      }
    },
    isShowHandle(val) {
      this.vcode_isShow = val;
    },
    async goForGetCodeClick() {
      if (this.forgetForm.mobile && this.timeOut <= 0) {
        this.vcode_successcallback = this.goForGetCode;
        this.vcode_isShow = true;
      }
    },
    async goForGetCode(codeText, guidText) {
      if (this.forgetForm.mobile && this.timeOut <= 0) {
        let data = {
          mobile: this.forgetForm.mobile,
          guid: guidText,
          Vcode: codeText
        };
        let result = await this.getForGetCode(data);
        if (result.ErrorCode === 0) {
          this.setTimeOut(60);
        } else {
          this.forgetErrorTip = result.ErrorMess;
        }
        // console.log(result);
      }
    },
    async toRegister() {
      this.isRegister = true;
      this.regForm.uname = "";
      this.regForm.pwd = "";
      this.regForm.mobileCode = "";
      this.regErrorTip = "";
      this.checked = true;
    },
    toforget() {
      this.forgetPass = true;
      this.forgetForm.mobile = "";
      this.forgetForm.password = "";
      this.forgetForm.password2 = "";
      this.forgetForm.code = "";
      this.forgetForm.uid = "";
    },
    jumpLogin() {
      window.location.href =
        config.jumpLoginUrl +
        "&r=" +
        encodeURI(this.returnurl.replace("5118", "5ce"));
    },
    passLogin() {
      this.isPassLogin = true;
      this.isReset = false;
      clearInterval(this.stateInterval);
      // clearInterval(this.stateInterval);
    },
    close() {
      this.isPassLogin = false;
      this.$emit("closeShowDialogs", false);
      clearInterval(this.stateInterval);
    },
    async register() {
      let Base64 = require("js-base64").Base64;
      if (this.checked) {
        this.regErrorTip = "";

        if (!this.regForm.uname) {
          this.regErrorTip = "手机号不能为空";
          return;
        } else {
          let reg = /^[0-9]{11}$/g;
          if (!reg.test(this.regForm.uname)) {
            this.regErrorTip = "手机格式不正确";
            return;
          }
        }
        if (!this.regForm.pwd) {
          this.regErrorTip = "密码不能为空";
          return;
        } else {
          if (this.regForm.pwd.length < 6) {
            this.regErrorTip = "密码不小于6-30位字符";
            return;
          }
        }
        if (!this.regForm.mobileCode) {
          this.regErrorTip = "验证码不能为空";
          return;
        }
        let newpad = this.regForm.pwd;
        this.regForm.pwd = Base64.encode(this.regForm.pwd);

        let result = await this.getUserRegister(this.regForm);

        if (result.status === 1) {
          this.$message({
            showClose: true,
            message: "注册成功",
            type: "success"
          });
          this.form.account = this.regForm.uname;
          this.form.password = newpad;
          this.login();

          // window.location.reload();
        } else {
          this.regErrorTip = "注册不成功";
        }
      }
    },
    async forget() {
      this.forgetErrorTip = "";
      if (!this.forgetForm.mobile) {
        this.forgetErrorTip = "手机号不能为空";
        return;
      } else {
        let reg = /^[0-9]{11}$/g;
        let reg1 = /[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}/gi;
        if (
          !reg.test(this.forgetForm.mobile) &&
          !reg1.test(this.forgetForm.mobile)
        ) {
          this.forgetErrorTip = "手机或邮箱格式不正确";
          return;
        }
      }
      if (!this.forgetForm.password) {
        this.forgetErrorTip = "密码不能为空";
        return;
      } else {
        if (this.forgetForm.password.length < 6) {
          this.forgetErrorTip = "密码不小于6-30位字符";
          return;
        }
      }
      if (!this.forgetForm.password2) {
        this.forgetErrorTip = "密码不能为空";
        return;
      } else {
        if (this.forgetForm.password2.length < 6) {
          this.forgetErrorTip = "密码不小于6-30位字符";
          return;
        }
      }
      if (this.forgetForm.password !== this.forgetForm.password2) {
        this.forgetErrorTip = "两次输入密码不一致";
        return;
      }
      if (!this.forgetForm.code) {
        this.forgetErrorTip = "验证码不能为空";
        return;
      }
      this.forgetForm.uid = this.getUid;
      let result = await this.getUserReset(this.forgetForm);
      if (result.errorCode === 0) {
        // this.forgetPass = false;
        // this.errorTip = "";
        // this.isReset = false;
        this.backLogin();
        this.$message({
          showClose: true,
          message: "密码修改成功",
          type: "success"
        });
      } else {
        this.$message({
          showClose: true,
          message: result.errorMess,
          type: "error"
        });
      }
    },
    async login() {
      let Base64 = require("js-base64").Base64;
      if (this.isLoading) {
        return;
      }
      this.errorTip = "";
      if (!this.form.account) {
        this.errorTip = "用户名不能为空";
        return;
      }
      if (!this.form.password) {
        this.errorTip = "密码不能为空";
        return;
      }
      if(this.isLoading==true){
        return;
      }
      this.isLoading = true;
      this.form.password = Base64.encode(this.form.password);
      let result = await this.userLogin(this.form);
      if (result.errorCode === 200201) {
        this.isReset = true;
        this.getUid = result.data;
      }
      if (result.success) {
        // if (this.saveUser) {
        //   this.setCookie(this.form.account, this.form.password, 30);
        // } else {
        //   this.clearCookie();
        // }
        // if (this.returnurl.indexOf("5118.com") === -1) {
        //   window.location.reload();
        // } else {
        //   window.location.href = this.returnurl.replace(
        //     "p-ai.5118",
        //     "preview.5ce"
        //   );
        // }
        this.isSetSaveState(false);
        window.location.reload();

        this.isLoading = false;
      } else {
        this.errorTip = result.errorMsg;
        this.isLoading = false;
      }
    },
    async getPublicQrCode() {
      let _this = this;
      _this.isOverdue = false;
      clearInterval(_this.stateInterval);
      let data = { returnurl: _this.returnurl };
      let result = await _this.publicQrCode(data);
      if (result.errorCode === 0) {
        _this.url = result.data.url;
        _this.checkCode(result.data.key);
      }
    },
    async checkCode(key) {
      let _this = this;
      let data = { key: key };
      _this.stateInterval = setInterval(async () => {
        let result = await _this.publicQrCodeState(data);
        if (result.errorCode === 0) {
          if (result.data.state === "tologin") {
            _this.publictologin(key);
            clearInterval(_this.stateInterval);
          }
        } else {
          _this.isOverdue = true;
          clearInterval(_this.stateInterval);
        }
      }, 1666);
    },
    async publictologin(key) {
      let _this = this;
      let data = { key: key };
      clearInterval(_this.stateInterval);
      let result = await _this.publicLogin(data);
      if (result.errorCode === 0) {
        if (result.data.state === "success") {
          this.isSetSaveState(false);
          window.location.reload();
          // console.log(this.returnurl);
          // if (this.returnurl.indexOf("5118.com") === -1) {
          //   window.location.reload();
          // } else {
          //   window.location.href = this.returnurl.replace(
          //     "p-ai.5118",
          //     "preview.5ce"
          //   );
          // }
        }
      }
    },
    //设置cookie方法
    setCookie(mobile, password, days) {
      // var text = CryptoJS.AES.encrypt(password, 'secret key 123');//使用CryptoJS方法加密
      var text = password; //使用CryptoJS方法加密
      var saveDays = new Date(); //获取时间
      saveDays.setTime(saveDays.getTime() + 24 * 60 * 60 * 1000 * days); //保存的天数
      Cookies.set("mobile", mobile, {
        expires: saveDays,
        path: "/"
      });
      Cookies.set("password", text, {
        expires: saveDays,
        path: "/"
      });
    },
    //读取cookie
    getCookie() {
      let mobile = Cookies.get("mobile") || "";
      if (mobile) {
        this.form.account = mobile;
      }
      let password = Cookies.get("password") || "";
      if (password) {
        //密码解密
        // var bytes = CryptoJS.AES.decrypt(password.toString(), "secret key 123");
        // var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        this.form.password = password;
      }
    },
    //清除cookie
    clearCookie() {
      this.setCookie("", "", 0); //账号密码置空，天数置0
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";

.document-dialog {
  .icons {
    display: inline-block;
    height: 16px;
    width: 16px;
    vertical-align: middle;
    margin-top: -3px;
  }
  .check-login {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    .anquan-tips {
      height: 25px;
      line-height: 25px;
      padding: 0 5px;
      border: 1px solid #f6a31d;
      color: #f6a31d;
      text-align: center;
      border-radius: 4px;
      font-size: 12px;
      background-color: #fdfbed;
      position: relative;
      margin-top: 8px;
      &:after {
        content: " ";
        display: block;
        position: absolute;
        border-left: 0;
        right: -7px;
        top: 6px;
        border: 4px solid transparent;
        border-left: 4px solid #fdfbed;
        z-index: 2;
      }
      &:before {
        content: " ";
        display: block;
        position: absolute;
        border-left: 0;
        right: -8px;
        top: 6px;
        border: 4px solid transparent;
        border-left: 4px solid #f6a31d;
      }
    }
    .topass {
      cursor: pointer;
      width: 60px;
      height: 60px;
      display: inline-block;
      background: url("../../assets/image/prompt/toaccount.png") no-repeat;
    }
    .toweixin {
      cursor: pointer;
      width: 60px;
      height: 60px;
      display: inline-block;
      background: url("../../assets/image/prompt/toqrcode.png") no-repeat;
    }
    .tips-info {
      background: url("../../assets/image/prompt/anquan.png") no-repeat 50%;
    }
  }
  .check-register {
    position: absolute;
    right: 15px;
    font-size: 14px;
    top: 35px;
    color: #0c7df5;
    cursor: pointer;
  }
  .icon-account-new {
    width: 36px;
    height: 18px;
    background: url(../../assets/image/icon/tuijian.png);
    position: absolute;
    top: 6px;
    right: 0;
    margin-right: 3px;
  }
  .getPublicQrCode {
    margin-left: 19px;
    width: 148px;
    height: 148px;
    position: absolute;
    top: 14px;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: white;
    cursor: pointer;
  }
  .app-account-qrcode {
    color: #fff;
    .qrcode {
      text-align: center;
      width: 100%;
      height: 260px;
      padding-top: 15px;
      .qrcode-box {
        width: 100%;
        height: 150px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        .qrcode-div {
          width: 150px;
          height: 150px;
          border: 1px solid #e2e2e2;
          position: relative;
          display: inline-block;
        }
        .tips-div {
          width: 150px;
          height: 150px;
          border: 1px solid #e2e2e2;
          position: relative;
          padding-left: 16px;
          display: inline-block;
          margin-left: 5px;
        }
      }
    }
    .qrcode-tips {
      width: 300px;
      margin: 0 auto;
      text-align: center;
      margin-top: -20px;
      color: #666;
      .scantext {
        font-size: 16px;
        text-align: left;
        display: inline-block;
        .scana {
          color: #0c7df5;
        }
      }
      i {
        display: inline-block;
        width: 42px;
        height: 40px;
        background: url("../../assets/image/prompt/loginscan.png") 50% no-repeat;
        margin-right: 15px;
        vertical-align: -3px;
      }
    }
  }
  .app-account-login {
    width: 100%;
    .agree {
      font-size: 12px;
      color: #999;
      a {
        color: #0c7df5;
        text-decoration: underline;
      }
    }
    .resetMsg {
      font-size: 12px;
      color: #ec9717;
      span {
        cursor: pointer;
        border-bottom: 1px solid #ec9717;
      }
    }
    .text {
      line-height: 38px;
      height: 38px;
      width: 100%;
      font-size: 14px;
      color: #555;
      background-color: white;

      padding: 0 10px 0 10px;
      display: block;
      border-radius: 4px;
    }
    .checkbox {
      padding-top: 20px;
      float: left;
      color: #999;
      input {
        vertical-align: middle;
      }
    }
    .forget-btn {
      padding-top: 20px;
      float: right;
      color: #999;
    }
    .button {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: #1059f6;
      margin-top: 30px;
      border-radius: 4px;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
    }
    .gbutton {
      .button();
      background-color: #ddd;
      cursor: not-allowed !important;
    }
    .getPhoneCode {
      display: inline-block;
      margin-left: 10px;
      border: 1px solid #1881ec;
      color: #1881ec;
      padding: 11px 25px;
      border-radius: 3px;
      background-color: #fff;
      cursor: pointer;
      margin-bottom: 15px;
      &:hover {
        background-color: #1881ec;
        color: #fff !important;
      }
    }
    .noPhoneCode {
      display: inline-block;
      margin-left: 10px;
      padding: 11px 25px;
      border-radius: 3px;
      background-color: #e4e4e4;
      color: #fff;
      margin-bottom: 15px;
      cursor: not-allowed;
    }
    .zhanghao {
      margin-top: 15px;
      line-height: 40px;
      height: 40px;
      width: 100%; /* border-bottom: solid 1px #676767; */
      border: 1px solid #dddddd;
      border-radius: 4px;
      font-size: 16px;
      color: #555;
      background-color: #f6f6f6;
      position: relative;
    }
    .img_01 {
      width: 16px;
      height: 16px;
      background: url(../../assets/image/icon/userName.png) center center
        no-repeat;
      position: absolute;
      top: 10px;
      left: 14px;
      z-index: 100;
    }
    .img_02 {
      width: 16px;
      height: 16px;
      background: url(../../assets/image/icon/passWord.png) center center
        no-repeat;
      position: absolute;
      top: 10px;
      left: 14px;
      z-index: 100;
    }
  }
  .error {
    /*height: 36px;*/
    /*line-height: 36px;*/
    color: #f33a64;
    font-size: 14px;
    /*text-align: center;*/
  }
  .footer {
    /*border-top: 1px solid #eee;*/
    /*padding-top: 15px;*/
    position: absolute;
    right: 15px;
    bottom: 10px;
    width: 100%;
    line-height: 24px;
    font-size: 14px;
    text-align: right;
    color: #999;
    a {
      color: @blue;
      /*text-decoration: underline;*/
    }
  }

  /*.login-tip {*/
  /*  text-align: center;*/
  /*  margin: 20px 0;*/
  /*}*/
  .dialog-tologin {
    background-color: @theme-color;
    color: white;
    border-radius: 20px;
    padding: 5px 15px;
  }
  .setborder {
    /*border-right: 1px solid #eee;*/
    /*width: 50%;*/
    /*padding-left: 40px;*/
  }
  .loginActive {
    font-weight: 600;
    color: @blue;
  }
  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #cacaca;
  }
  /deep/.close {
    color: #fff;
    cursor: pointer;
    position: absolute;
    margin-left: 15px;
    margin-top: -50px;
    font-size: 25px;
  }
  /deep/.dialog-title {
    font-size: 16px;
    display: inline-block;
    .title_name {
      display: inline-block;
      float: left;
      width: auto;
      height: 40px;
      margin-left: 5px;
      font-weight: 700;
      line-height: 40px;
      border-bottom: 2px solid #0c7df5;
      margin-bottom: -4px;
      font-size: 18px;
      letter-spacing: 1px;
      color: #888;
    }
    .explain {
      font-size: 12px;
      color: #999;
      float: left;
      margin-top: 12px;
      margin-left: 5px;
    }
  }
  /deep/.el-dialog__header {
    border-bottom: 1px solid #e2e3e5;
    padding: 25px 10px 0px 10px;
  }
  /deep/.el-dialog__body {
    padding: 20px 20px 0 20px;
    height: 370px;
  }
  /deep/.el-dialog {
    border-radius: 4px;
  }
}
</style>
